<div class="wrap printMe">
  <div class="header">
    <h1>Encodages</h1>
    <div class="search_bar">
      <form [formGroup]="searchForm">
        <input type="text" placeholder="Votre recherche ..." (input)="applyFilter($event.target.value)"
          formControlName="keyword">
        <fa-icon [icon]=" faTimes" (click)="resetSearch()" *ngIf="filterValue"></fa-icon>
        <fa-icon [icon]=" faSearch"></fa-icon>
      </form>
    </div>
  </div>
  <div class="filter">
    <form [formGroup]="filterRecordsForm" (ngSubmit)="filterRecords('submit')">
      <div class="author_date_export">
        <div class="author_date">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Utilisateur</mat-label>
            <mat-select formControlName="username"  (selectionChange)="getCategories($event.value, 'user', $event) ">
              <mat-option value="Tous">Tous</mat-option>
              <mat-option *ngFor="let u of users" [value]="u.username">{{u.username}}</mat-option>
            </mat-select>
            <mat-error>{{'updateUser.username.erromMessage' | translate}}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Du</mat-label>
            <input matInput [matDatepicker]="from" formControlName="from">
            <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
            <mat-datepicker #from></mat-datepicker>
          </mat-form-field>
          <span>-</span>
          <mat-form-field appearance="outline">
            <mat-label>Au</mat-label>
            <!-- <input matInput [max]="today" [min]="filterRecordsForm.get('from').value" [matDatepicker]="to"
              formControlName="to"> -->
            <input matInput [matDatepicker]="to" formControlName="to">
            <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
            <mat-datepicker #to></mat-datepicker>
          </mat-form-field>
        </div>
        <div class='btn_action'>
          <fa-icon [icon]="faRedoAlt" (click)="resetFilter()"></fa-icon>
          <fa-icon [icon]="faPrint" [style.margin-left.px]="10" (click)="printPage()"></fa-icon>
          <fa-icon [icon]="faFileExcel" [style.margin-left.px]="10" (click)="filterRecords('export')"></fa-icon>
        </div>
      </div>
      <div class="origin_step_category">
        <div class="origin_step_category_inputs">
          <mat-form-field class="example-full-width" appearance="outline" *ngIf="this.steps">
            <mat-label>Étape</mat-label>
            <mat-select (selectionChange)="getCategories($event.value, 'step')" formControlName="step">
              <mat-option *ngFor="let s of steps" [value]="s">{{s.description}}</mat-option>
            </mat-select>
            <mat-error>{{'updateUser.username.erromMessage' | translate}}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="example-full-width" appearance="outline" *ngIf="type.length">
            <mat-label>Type</mat-label>
            <mat-select (selectionChange)="getCategories($event.value, 'type');" formControlName="type">
              <mat-option *ngFor="let c of choiceType" [value]="c">{{c === 'Input'? 'Entrée' : 'Sortie'}}</mat-option>
            </mat-select>
            <mat-error>{{'updateUser.username.erromMessage' | translate}}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="example-full-width" appearance="outline" *ngIf="categories.length">
            <mat-label>Catégorie</mat-label>
            <mat-select (selectionChange)=" getCategories($event.value, 'category')" formControlName="category">
              <mat-option *ngFor="let c of categories" [value]="c">{{c.name}}</mat-option>
            </mat-select>
            <mat-error>{{'updateUser.username.erromMessage' | translate}}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="example-full-width" appearance="outline" *ngIf="subCategories.length">
            <mat-label>Sous-catégorie</mat-label>
            <mat-select formControlName="subCategory" (selectionChange)="getCategories($event.value, 'subCategory' )">
              <mat-option *ngFor="let s of subCategories" [value]="s">{{s.name}}</mat-option>
            </mat-select>
            <mat-error>{{'updateUser.username.erromMessage' | translate}}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="example-full-width" appearance="outline" *ngIf="subSubCategories.length">
            <mat-label>Sous sous-catégorie</mat-label>
            <mat-select formControlName="subSubCategory"
              (selectionChange)="getCategories($event.value, 'subSubCategory' )">
              <mat-option *ngFor="let s of subSubCategories" [value]="s">{{s.name}}</mat-option>
            </mat-select>
            <mat-error>{{'updateUser.username.erromMessage' | translate}}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="example-full-width" appearance="outline" *ngIf="subSubSubCategories.length">
            <mat-label>Sous sous sous-catégorie </mat-label>
            <mat-select formControlName="subSubSubCategory">
              <mat-option *ngFor="let s of subSubSubCategories" [value]="s">{{s.name}}</mat-option>
            </mat-select>
            <mat-error>{{'updateUser.username.erromMessage' | translate}}
            </mat-error>
          </mat-form-field>
          <button type="submit">
            <fa-icon [icon]="faSearch"></fa-icon>
          </button>
        </div>
      </div>
    </form>
  </div>

  <div class="container">
    <table mat-table [dataSource]="dataSource" matSort matPaginator class="mat-elevation-z8">
      <ng-container matColumnDef="creation">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="createdOn" justify="end">Création</th>
        <td mat-cell *matCellDef="let element"> {{element.createdOn| date}} </td>
      </ng-container>

      <ng-container matColumnDef="step">
        <th mat-header-cell *matHeaderCellDef mat-sort-header justify="end">Étape</th>
        <td mat-cell *matCellDef="let element">{{element.step?.description}} </td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="type" justify="end">Type</th>
        <td mat-cell *matCellDef="let element"> {{element.type === 'Input'? 'Entrée' : 'Sortie'}} </td>
      </ng-container>
      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="category" justify="end">Catégorie</th>
        <td mat-cell *matCellDef="let element"> {{element.category?.name}} </td>
      </ng-container>
      <ng-container matColumnDef="subcategory">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="subcategory" justify="end">Sous-catégorie</th>
        <td mat-cell *matCellDef="let element"> {{element.category?.subCategory?.name || '-'}}
          {{ element.category?.subCategory?.subCategory? '> ' +
          element.category?.subCategory?.subCategory?.name || '' :
          ''
          }}
          {{
          element.category?.subCategory?.subCategory?.subCategory?
          '> ' + element.category?.subCategory?.subCategory?.subCategory?.name || '':
          ''
          }} </td>
      </ng-container>
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="value" justify="end">Valeur</th>
        <td mat-cell *matCellDef="let element"> {{element.value}} {{getTypeValue(element.category.unit)}} </td>
      </ng-container>
      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef  justify="end">Supp.</th>
        <td mat-cell *matCellDef="let element">
          <fa-icon [icon]='faTrashAlt' (click)="deleteRecord(element.id)"></fa-icon>
        </td>
      </ng-container>



      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"> </tr>

    </table>

    <div class="notResul" *ngIf="!dataSource.data.length || !dataSource.filteredData.length">
      <p>Il n'y a pas de résultat</p>
    </div>


    <mat-paginator *ngIf="paginationRecords" [pageSize]="paginationRecords?.pageSize"
      [length]="paginationRecords?.totalRecords" [pageIndex]="paginationRecords?.pageNumber - 1"
      (page)="onPageRecordsChanged($event)" [hidePageSize]="true">
    </mat-paginator>

  </div>
</div>
